module.exports = __webpack_public_path__ + "img/172-Bleu Monument.jpg";